import JiraConfiguration from './JiraConfiguration';

export const CONNECTOR_CONFIG_COMPONENTS = {
  'jira-cloud': JiraConfiguration,
  // Add other connector types here as they're implemented
};
